var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"services-catalogue"}},[_c('page-section',{attrs:{"title":"Catalogo servizi","icon":"it-folder"}},[[_c('div',{staticClass:"row"},_vm._l((_vm.services),function(item){return _c('div',{key:item.id,staticClass:"col-12 col-lg-4"},[_c('service-card',{attrs:{"value":item}})],1)}),0)]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }